export const humanDate = (date: string): string => {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const humanShortDate = (date: string): string => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/**
 * Formats a given date string into a short, human-readable date in the format:
 * `MMM DD, YYYY` (e.g., "Aug 10, 2022").
 *
 * @param {string} date - A date string in the format of `YYYY-MM-DD`.
 * @returns {string} A formatted date string in the form `MMM DD, YYYY`.
 */
export const humanShortDateLocal = (date: string): string => {
  if (!date) return '';

  return new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
